import router, { useRouter } from 'next/router';
import { useEffect, useMemo } from 'react';
import { EntryPresenter } from '~/components/entry/Presenter';
import { useRegion } from '~/features/region/hooks/useRegion';
import { regionService } from '~/features/region/regionService';
import { useLocale } from '~/hooks/useLocale';
import { authConstants, getOALocale } from '~/masterdata/auth';
import { entryPersistences } from '~/persistence';
import { sendGAEvent } from '~/utils/gtag';

export const EntryContainer = () => {
  const { utm_campaign, utm_source, utm_medium } = router.query;
  const { asPath } = useRouter();
  const { regionCode: storedRegionCode } = useRegion();
  const { lang } = useLocale();

  const { RegisterUrl, LoginUrl } = useMemo(() => {
    const regionCode = regionService.getRegionCodeFromPathName(asPath) ?? storedRegionCode;
    const locale = getOALocale(regionCode, lang);
    return {
      RegisterUrl: [
        authConstants.BASE_URL,
        authConstants.REGISTER_PATH,
        authConstants.buildRegisterQueryStrings(locale),
      ].join(''),
      LoginUrl: [
        authConstants.BASE_URL,
        authConstants.LOGIN_PATH,
        authConstants.buildLoginQueryStrings(locale),
      ].join(''),
    };
  }, [asPath, storedRegionCode, lang]);

  useEffect(() => {
    if (!utm_campaign || !utm_source || !utm_medium || entryPersistences.CampaignTag.value) return;

    const tag = `${utm_campaign}_${utm_source}_${utm_medium}`;
    entryPersistences.CampaignTag.set(tag);
    entryPersistences.Campaigns.set({
      utm_campaign: utm_campaign.toString(),
      utm_source: utm_source.toString(),
      utm_medium: utm_medium.toString(),
    });
    sendGAEvent({
      action: 'pageView',
      category: 'page',
      label: `top_${tag}`,
      value: 1,
    });
  }, [utm_campaign, utm_source, utm_medium]);

  return <EntryPresenter RegisterUrl={RegisterUrl} LoginUrl={LoginUrl} />;
};
